/**
 * parseSuggestion — interpreta a query string `parameters` de uma sugestão do
 * /app/suggestions (ex.: "module=emails&keywords=[a;b]&domains=[@gmail.com|Gmail]&
 * sites=['instagram.com']&places=['-27,−48|Centro']") e devolve um pré-preenchimento do
 * formulário de captura. As listas usam `[...]`/`;` como no legado; aspas simples são
 * removidas.
 */
import type { ListModule } from '../config/constants';

export interface SuggestionForm {
  module: ListModule;
  keywords?: string;
  sites?: string[];
  domains?: string[];
  places?: string[];
  areaCode?: string;
  country?: string;
  countryName?: string;
}

/** Extrai os itens de uma lista no formato `[a;b;c]`, tirando aspas simples das pontas. */
function parseList(raw: string): string[] {
  const inner = raw.replace(/^\[/, '').replace(/\]$/, '');
  if (inner.length === 0) return [];
  return inner
    .split(';')
    .map((v) => v.trim().replace(/^'/, '').replace(/'$/, ''))
    .filter((v) => v.length > 0);
}

/** Sugestões do Hunter são ignoradas: o módulo saiu do painel em 17/10/2026. */
const MODULES: readonly string[] = ['emails', 'phones', 'places'];

export function parseSuggestion(parameters: string): SuggestionForm | null {
  const params = new URLSearchParams(parameters);
  const module = params.get('module');
  if (!module || !MODULES.includes(module)) return null;

  const form: SuggestionForm = { module: module as ListModule };
  const keywords = params.get('keywords');
  if (keywords) form.keywords = parseList(keywords).join('\n');
  const sites = params.get('sites');
  if (sites) form.sites = parseList(sites);
  const domains = params.get('domains');
  if (domains) form.domains = parseList(domains);
  const places = params.get('places');
  if (places) form.places = parseList(places);
  const areaCode = params.get('area_code');
  if (areaCode) form.areaCode = areaCode;
  const country = params.get('country');
  if (country) form.country = country;
  const countryName = params.get('countryName');
  if (countryName) form.countryName = countryName;
  return form;
}
